import { NgxUiLoaderConfig, NgxUiLoaderModule, PB_DIRECTION, POSITION, SPINNER } from 'ngx-ui-loader';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationRef, CUSTOM_ELEMENTS_SCHEMA, DoBootstrap, Injector, NgModule } from '@angular/core';
import { RequestInterceptorService } from './interceptor/request-interceptor.service';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ChatMainComponent } from './components/chat-main/chat-main.component';
import { BrowserModule } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { createCustomElement } from '@angular/elements';
import { AppComponent } from './app.component';
import { ToastrModule } from 'ngx-toastr';


const ngxToasterConfiguration = {
  timeOut: environment.ngxToasterTimeout,
  positionClass: "toast-top-right",
  preventDuplicates: true,
  closeButton: true,
  progressBar: true,
};

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: "#546e7a",
  bgsPosition: POSITION.bottomRight,
  bgsSize: 40,
  bgsType: SPINNER.threeStrings,
  fgsType: SPINNER.threeStrings,
  pbDirection: PB_DIRECTION.leftToRight,
  pbThickness: 5,
  text: "Loading...",
  textColor: "#FFFFFF",
  textPosition: POSITION.centerCenter,
  fgsColor: "#B7A196",
  pbColor: "#B7A196",
  blur: 7,
};

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    ToastrModule.forRoot(ngxToasterConfiguration),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptorService,
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
  bootstrap: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule implements DoBootstrap {
  constructor(private injector: Injector) { }

  ngDoBootstrap() {
    if (environment.embeddedMode) {
      const chatElement = createCustomElement(ChatMainComponent, {
        injector: this.injector,
        strategyFactory: undefined,
      });

      const proto = chatElement.prototype as any;
      proto.attachShadow = function(init: ShadowRootInit) {
        return HTMLElement.prototype.attachShadow.call(this, {
          ...init,
          mode: 'open',
        });
      };

      customElements.define('titan-dms-chatbot', chatElement);
    }

    const appRoot = document.createElement('app-root');
    document.body.appendChild(appRoot);
    const appRef = this.injector.get(ApplicationRef);
    appRef.bootstrap(AppComponent);
  }
}
